// extracted by mini-css-extract-plugin
export default {"titlePadding":"AdvancedView_titlePadding__EMdGB","rulesMargin":"AdvancedView_rulesMargin__YWwbH"};